module.exports = __webpack_public_path__ + "img/p5.e95b1a8f.png";